import React from 'react';

const About = () => {
  return (
    <section id="about" className="section">
      <h2>About Me</h2>
      <p>Hey, I'm Debasish Behera, an 18-year-old founder and developer from India. </p>
      <p>
      Right now, I'm all about Acadmyc, a slick SaaS platform I'm cooking up for universities. Think of it as the ultimate campus hub – class updates, club deets, and networking, all in one spot.
{/* 
But guess what? That's just the warm-up. Me and my crew are diving into another gig, crafting a next-gen personal AI, straight outta sci-fi. Picture having your own JARVIS-style buddy, but real. It's like leveling up your digital game. */}
      </p>
    </section>
  );
};

export default About;
